import isMobileWidth from 'lib/isMobileWidth';
import openProactive from 'actions/configuration/openProactive';
import uiEvents from 'events/ui';

export default function executeRule(dispatch, getState) {
  const state = getState();
  const hasWidgetBeenMinimized = !!state.ui.minimizedAt; // true if the widget ever been minimized by user

  // display the widget
  dispatch(uiEvents.unsuppress());
  dispatch(uiEvents.updateVisibility(true));

  if (isMobileWidth()) {
    return;
  }

  let openDelay = state.app.currentRule.rule.openDelay;
  if (openDelay && !hasWidgetBeenMinimized) {
    setTimeout(() => {
      dispatch(openProactive);
    }, openDelay);
  }
}
